import React from 'react';
import styled from 'styled-components';
import { Image, Type } from '@spotify-internal/encore-creator-web';
import {
  spacer16,
  spacer24,
  spacer48,
  screenMdMin,
  gray10,
  aquamarine,
} from '@spotify-internal/encore-foundation';
import { AzureLink } from './styles';
import { pageConstraintStyles, PAGE_GUTTER } from './styles';
import { FormattedMessage } from 'react-intl';

export function Testimonials() {
  return (
    <FullWidthContainer>
      <TestimonialsContainer>
        <Testimonial>
          <TestimonialHeader>
            <TestimonialCover
              src="/images/landing_page/testimonial-01-cover.png"
              alt="Revisionist History cover"
            />
            <TestimonialAvatar
              src="/images/landing_page/testimonial-01-profile.png"
              alt="Heather Fain"
            />
          </TestimonialHeader>
          <TestimonialTitle>
            <FormattedMessage
              id="landing-page.testimonials.revisionist-history"
              defaultMessage="Revisionist History"
            />
          </TestimonialTitle>
          <TestimonialContent>
            <FormattedMessage
              id="landing-page.testimonials.revisionist-history-testimonial"
              defaultMessage="“Spotify for Podcasters provides us with an easy way to track audience growth for
          established shows, like Malcolm Gladwell’s Revisionist History, and for those that are
          just starting, like Michael Lewis’s Against the Rules. The feedback we gather about how
          our episodes are engaging listeners — and who those listeners are — helps us
          build effective marketing strategies.”"
            />
          </TestimonialContent>
          <Type as="p" variant={Type.body2} color={aquamarine}>
            <FormattedMessage
              id="landing-page.testimonials.revisionist-history-cred"
              defaultMessage="<bold>Heather Fain</bold> {break} CMO, Pushkin Industries {break} <azure>Revisionist History</azure>"
              values={{
                bold: chunks => (
                  <Type as="span" weight={Type.bold}>
                    {chunks}
                  </Type>
                ),
                break: <br />,
                azure: chunks => (
                  <AzureLink
                    href="https://open.spotify.com/show/2LOJaYKijiwNefCvzczyib?si=jqZkktjOQu-v-4J9Ba41jg"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {chunks}
                  </AzureLink>
                ),
              }}
            />
          </Type>
        </Testimonial>
        <Testimonial>
          <TestimonialHeader>
            <TestimonialCover
              src="/images/landing_page/testimonial-02-cover.png"
              alt="Therapy for Black Girls"
            />
            <TestimonialAvatar
              src="/images/landing_page/testimonial-02-profile.png"
              alt="Dr. Joy Harden Bradford"
            />
          </TestimonialHeader>
          <TestimonialTitle>
            <FormattedMessage
              id="landing-page.testimonials.therapy-for-black-girls"
              defaultMessage="Therapy for Black Girls"
            />
          </TestimonialTitle>
          <TestimonialContent>
            <FormattedMessage
              id="landing-page.testimonials.therapy-for-black-girls-testimony"
              defaultMessage="“I love having Spotify as a home for my podcast. I use the analytics provided to see which
            topics my listeners enjoy most and then craft additional content around these topics to
            dig deeper and further engage my audience. Listeners have also commented that they enjoy
            being able to find the podcast on a platform they already use which is a win for everyone.
            I appreciate that Spotify takes special care to be sure that the people who need and want
            the information on my podcast can access it.”"
            />
          </TestimonialContent>
          <Type as="p" variant={Type.body2} color={aquamarine}>
            <FormattedMessage
              id="landing-page.testimonials.therapy-for-black-girls-cred"
              defaultMessage="<bold>Dr. Joy Harden Bradford</bold> {break} Host {break} <azure>Therapy for Black Girls</azure>"
              values={{
                bold: chunks => (
                  <Type as="span" weight={Type.bold}>
                    {chunks}
                  </Type>
                ),
                break: <br />,
                azure: chunks => (
                  <AzureLink
                    href="https://open.spotify.com/show/7kPXrtK66kXyiqpKTtsqNN"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {chunks}
                  </AzureLink>
                ),
              }}
            />
          </Type>
        </Testimonial>
        <Testimonial>
          <TestimonialHeader>
            <TestimonialCover
              src="/images/landing_page/testimonial-03-cover.png"
              alt="Beach Too Sandy, Water Too Wet cover"
            />
            <TestimonialAvatar
              src="/images/landing_page/testimonial-03-profile.png"
              alt="Alex and Christine Schiefer"
            />
          </TestimonialHeader>
          <TestimonialTitle>
            <FormattedMessage
              id="landing-page.testimonials.beach-too-sandy"
              defaultMessage="Beach Too Sandy, Water Too Wet"
            />
          </TestimonialTitle>
          <TestimonialContent>
            <FormattedMessage
              id="landing-page.testimonials.beach-too-sandy-testimonial"
              defaultMessage="“Support from Spotify has given us the opportunity to reach listeners from all over the
            world. Not even a month into our show, we found ourselves featured on the podcast
            homepage, leading to massive growth in our audience. Spotify’s platform continues to
            unlock our show’s full potential.”"
            />
          </TestimonialContent>
          <Type as="p" variant={Type.body2} color={aquamarine}>
            <FormattedMessage
              id="landing-page.testimonials.beach-too-sandy-cred"
              defaultMessage="<bold>Alex and Christine Schiefer</bold> {break} Hosts {break} <azure>Beach Too Sandy, Water Too Wet</azure>"
              values={{
                bold: chunks => (
                  <Type as="span" weight={Type.bold}>
                    {chunks}
                  </Type>
                ),
                break: <br />,
                azure: chunks => (
                  <AzureLink
                    href="https://open.spotify.com/show/0UfNJ2DoIfIveU2hghm1Io"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {chunks}
                  </AzureLink>
                ),
              }}
            />
          </Type>
        </Testimonial>
      </TestimonialsContainer>
    </FullWidthContainer>
  );
}

const FullWidthContainer = styled.div`
  background-color: ${gray10};
  margin: 0 auto;
  width: 100%;
`;

const TestimonialsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${spacer48};
  padding: 50px ${spacer16};

  @media (min-width: ${screenMdMin}) {
    ${pageConstraintStyles}

    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 68px;
    padding: 110px ${PAGE_GUTTER} 92px;
  }
`;

const TestimonialCover = styled.img`
  width: 275px;

  @media (min-width: ${screenMdMin}) {
    width: 150px;
  }
`;

const TestimonialAvatar = styled(Image).attrs({
  crop: true,
  circle: true,
})`
  bottom: 0;
  position: absolute;
  transform: translateX(-50%);
  width: 136px;
  height: 136px;

  @media (min-width: ${screenMdMin}) {
    width: 75px;
    height: 75px;
  }
`;

const TestimonialHeader = styled.div`
  position: relative;
`;

const Testimonial = styled.div`
  z-index: 1;
`;

const TestimonialTitle = styled(Type).attrs({
  forwardedAs: 'h3',
  variant: Type.heading3,
})`
  font-size: 27px;
  padding: ${spacer24} 0;
  color: ${aquamarine};
`;

const TestimonialContent = styled(Type).attrs({
  forwardedAs: 'p',
  variant: Type.body1,
})`
  line-height: 26px;
`;
